if (!customElements.get('custom-bundles')) {
  customElements.define('custom-bundles', class CustomBundles extends HTMLElement {
    connectedCallback() {
      this.selects = this.querySelectorAll('[data-bundle-select]');
      this.output = this.querySelector('[data-bundle-output]');
      this.errorEl = this.querySelector('[data-bundle-error]');
      this.errorMsg = this.dataset.error || '';
      this.selectedLabel = this.dataset.selectedLabel || '';

      try {
        this.includedComponents = this.output && this.output.value ? JSON.parse(this.output.value) : [];
      } catch (e) {
        this.includedComponents = [];
      }

      const formId = this.output ? this.output.getAttribute('form') : null;
      this.form = formId ? document.getElementById(formId) : this.closest('form');

      this.selects.forEach((sel) => {
        sel.addEventListener('change', () => this.handleChange(sel));
      });

      if (this.form) {
        this.form.addEventListener('submit', this.validate.bind(this), true);
      }
    }

    handleChange(select) {
      const item = select.closest('.custom-bundles__item');
      if (item) {
        const subtitle = item.querySelector('[data-bundle-subtitle]');
        const selectedSpan = item.querySelector('[data-bundle-selected]');
        const opt = select.selectedOptions[0];
        if (selectedSpan) {
          if (opt && opt.value) {
            const title = opt.dataset.title || opt.textContent.trim();
            selectedSpan.textContent = title;
            if (subtitle) subtitle.hidden = false;
          } else {
            selectedSpan.textContent = '';
            if (subtitle) subtitle.hidden = true;
          }
        }
      }

      if (this.errorEl && !this.errorEl.hidden) {
        const hasEmpty = [...this.selects].some((s) => !s.value);
        if (!hasEmpty) this.errorEl.hidden = true;
      }

      this.updateOutput();
    }

    updateOutput() {
      if (!this.output) return;

      const selected = [...this.selects]
        .map((s) => s.selectedOptions[0])
        .filter((opt) => opt && opt.value)
        .map((opt) => ({
          id: parseInt(opt.value, 10),
          price: parseInt(opt.dataset.price, 10),
        }));

      const all = [...this.includedComponents, ...selected];
      this.output.value = JSON.stringify(all);
    }

    validate(evt) {
      const empty = [...this.selects].find((s) => !s.value);
      if (empty) {
        evt.preventDefault();
        evt.stopImmediatePropagation();

        if (this.errorEl) {
          this.errorEl.textContent = this.errorMsg;
          this.errorEl.hidden = false;
        }

        empty.scrollIntoView({ behavior: 'smooth', block: 'center' });
        empty.focus();
        return;
      }

      if (this.errorEl) this.errorEl.hidden = true;
      this.updateOutput();
    }
  });
}
